// src/templates/casestudy.tsx
import React, { useState } from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import {
  Box,
  Breadcrumbs,
  Card,
  CardContent,
  CardMedia,
  Container,
  Divider,
  Grid,
  IconButton,
  Link,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import twitter from "../images/new_website/icons/social-icons/twitter.svg"
import linkedin from "../images/new_website/icons/social-icons/linkedIn.svg"
import pressBanner from "../images/press-release/drata-partner-invimatic-banner.jpg"
import jhanviCMO from "../images/about/jhanvi.jpg"
import quote from "../images/icons/double-quote.svg"
import moreImage1 from "../images/press-release/invimatic-iso-more-news-1.png"
import moreImage2 from "../images/press-release/invimatic-iso-more-news-2.png"
import moreImage4 from "../images/press-release/invimatic-iso-more-news-4.png"
import moreImage5 from "../images/press-release/invimatic-iso-more-news-5.png"
import moreImage6 from "../images/press-release/invimatic-iso-more-news-6.png"
import chatIcon from "../images/icons/chatIcon.svg"
import Enquiry from "../components/enqiry"

interface BusinessBenefit {
  title: string
  details: string
}

interface Implementation {
  title: string
  details: string
}

interface CaseStudyTemplateProps {
  pageContext: {
    id: string
    title: string
    introduction?: string
    metaTitle?: string
    metaDescription?: string
    metaKeywords?: string
    challenges: string
    solutions: string
    implementation?: Implementation[]
    businessBenefits?: BusinessBenefit[]
    takeaways: string
    image: string
    caseStudyTeaser: string
    dontMissOut: string
  }
}

const pressReleaseStyle = {
  mainWrapper: {
    backgroundColor: "#eeeeee",
  },
}

const IsoCertificationInvimatic: React.FC<CaseStudyTemplateProps> = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  // const isTablet = useMediaQuery(theme.breakpoints.up('md'));

  const socialMediaIcons = [
    {
      icon: linkedin,
      ariaLabel: "LinkedIn",
      url: "https://in.linkedin.com/company/invimatic",
    },
    { icon: twitter, ariaLabel: "Twitter", url: "https://x.com/Invimatictech" },
  ]

  const newsItems = [
    {
      id: 1,
      title: "Bingham News Chronicle",
      excerpt:
        "Invimatic Achieves ISO 27001:2022 Certification, Setting New Benchmarks in SaaS Security.",
      author: "AB Newswire",
      image: moreImage1,
      url: "https://business.am-news.com/am-news/markets/article/abnewswire-2025-3-3-invimatic-achieves-iso-270012022-certification-setting-new-benchmarks-in-saas-security/",
    },
    {
      id: 2,
      title: "The Punxsutawney Spirit",
      excerpt:
        "Invimatic Achieves ISO 27001:2022 Certification, Setting New Benchmarks in SaaS Security",
      author: "AB Newswire",
      image: moreImage2,
      url: "https://business.punxsutawneyspirit.com/punxsutawneyspirit/markets/article/abnewswire-2025-3-3-invimatic-achieves-iso-270012022-certification-setting-new-benchmarks-in-saas-security/",
    },
    {
      id: 4,
      title: "The Saline Courier",
      excerpt:
        "Invimatic Achieves ISO 27001:2022 Certification, Setting New Benchmarks in SaaS Security",
      author: "AB Newswire",
      image: moreImage4,
      url: "http://business.bentoncourier.com/bentoncourier/markets/article/abnewswire-2025-3-3-invimatic-achieves-iso-270012022-certification-setting-new-benchmarks-in-saas-security/",
    },
    {
      id: 5,
      title: "SMP The Daily Press",
      excerpt:
        "Invimatic Achieves ISO 27001:2022 Certification, Setting New Benchmarks in SaaS Security",
      author: "AB Newswire",
      image: moreImage5,
      url: "https://business.smdailypress.com/smdailypress/markets/article/abnewswire-2025-3-3-invimatic-achieves-iso-270012022-certification-setting-new-benchmarks-in-saas-security/",
    },
    {
      id: 6,
      title: "Mammoth Times",
      excerpt:
        "Invimatic Achieves ISO 27001:2022 Certification, Setting New Benchmarks in SaaS Security",
      author: "AB Newswire",
      image: moreImage6,
      url: "https://business.mammothtimes.com/mammothtimes/markets/article/abnewswire-2025-3-3-invimatic-achieves-iso-270012022-certification-setting-new-benchmarks-in-saas-security/",
    },
  ]

  return (
    <Layout showBlackNavbar={true}>
      <Seo
        title="Invimatic Partners with Drata to Promote Compliance Automation for SaaS Businesses"
        description="Invimatic partners with Drata to deliver automated continuous compliance solutions and improved security for SaaS businesses, streamlining SOC 2 certifications."
        keywords="Drata Partners"
      />
      <section className="press-section" style={pressReleaseStyle.mainWrapper}>
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              mt: "60px",
            }}
          >
            <Grid item xs={12} md={8}>
              <Box sx={{ pt: 3.75, mt: 4, mb: 6, bgcolor: "white" }}>
                <Stack spacing={3.25}>
                  {/* Breadcrumbs */}
                  <Breadcrumbs
                    separator=">"
                    aria-label="breadcrumb"
                    sx={{ pl: 3.75, pr: 3.75 }}
                  >
                    <Link
                      href="/"
                      underline="none"
                      color="#a7b2c0"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Typography variant="body2" color="#a7b2c0">
                        Home
                      </Typography>
                    </Link>
                    <Link
                      href="/press-releases/"
                      underline="none"
                      color="#a7b2c0"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body2" color="#a7b2c0">
                        Newsroom
                      </Typography>
                    </Link>
                    <Typography variant="body2" color="text.primary">
                      Press Release
                    </Typography>
                  </Breadcrumbs>

                  {/* Title */}
                  <Typography
                    variant="h4"
                    fontWeight="bold"
                    padding={"0px 30px"}
                  >
                    Invimatic Partners with Drata to Supercharge Compliance
                    Automation for SaaS Businesses
                  </Typography>

                  {/* Featured Image */}
                  <img
                    srcSet={pressBanner}
                    src={pressBanner}
                    loading="lazy"
                    alt="Press Release Banner"
                    style={{ width: "100%", height: "auto" }}
                  />

                  {/* Article Content */}
                  <Stack spacing={2.5} padding="0px 30px">
                    <Typography
                      variant="body1"
                      fontSize="18px"
                      lineHeight="28px"
                    >
                      <Box
                        component="span"
                        fontWeight="bold"
                        color="text.primary"
                      >
                        Pune, India, April 22, 2025 – Invimatic,
                      </Box>{" "}
                      <Box component="span">
                        a secure SaaS enablement company and provider of custom
                        product engineering solutions, is proud to announce its
                        strategic partnership with Drata, a leading security and
                        compliance automation platform. This collaboration aims
                        to empower SaaS companies with streamlined, automated
                        compliance processes, improving their ability to achieve
                        and maintain certifications such as SOC 2.​
                      </Box>
                    </Typography>

                    <Typography
                      variant="body1"
                      fontSize="18px"
                      lineHeight="28px"
                    >
                      Drata's platform offers continuous monitoring and evidence
                      collection of a company's security controls, simplifying
                      audit readiness and reducing manual efforts. By
                      integrating Drata's capabilities, Invimatic enriches its
                      commitment to delivering secure, compliant solutions that
                      meet the evolving needs of its clients.
                    </Typography>

                    {/* Quote Section */}
                    <Box
                      sx={{
                        position: "relative",
                        height: "150px",
                      }}
                    >
                      <Box
                        sx={{
                          position: "relative",
                        }}
                      >
                        <Box
                          component="img"
                          src={quote}
                          alt="Quote mark"
                          sx={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                          }}
                        />
                        <Typography
                          variant="body1"
                          fontSize="18px"
                          lineHeight="26px"
                          fontStyle="italic"
                          sx={{ pt: 1.5 }}
                        >
                          "Partnering with Drata aligns with our mission to
                          provide our clients with the tools they need to
                          navigate the complex landscape of compliance," said
                          Jhanvi Reddy, CMO and Founder at Invimatic. "This
                          collaboration enables us to offer enhanced security
                          and compliance solutions, allowing our clients to
                          focus on innovation and growth."
                        </Typography>
                      </Box>
                    </Box>

                    <Stack
                      direction="row"
                      spacing={1.5}
                      alignItems="center"
                      mt="0px !important"
                    >
                      <Box
                        component="img"
                        src={jhanviCMO}
                        srcSet={jhanviCMO}
                        alt="Jhanvi Image"
                        sx={{
                          width: "42px",
                          height: "42px",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                      <Box>
                        <Typography
                          variant="body1"
                          color="rgba(37, 106, 163, 1)"
                          fontSize="20px"
                          lineHeight="28px"
                          fontWeight="600"
                        >
                          Jhanvi Reddy
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          fontSize="14px"
                          lineHeight="28px"
                        >
                          CMO and Founder at Invimatic
                        </Typography>
                      </Box>
                    </Stack>

                    <Typography variant="body1" fontSize="18px">
                      <Box component="span" fontWeight="bold" lineHeight="28px">
                        About Invimatic:
                        <br />
                      </Box>
                      <Box component="span" lineHeight="28px">
                        Invimatic is a trusted provider of secure SaaS
                        enablement, offering continuous compliance, product
                        engineering, and staff augmentation services. By
                        integrating cutting-edge security, innovation, and
                        expertise, Invimatic empowers businesses to scale
                        securely while ensuring data protection and regulatory
                        compliance.
                      </Box>
                    </Typography>

                    {/* Contact Information */}
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      width="100%"
                    >
                      <Link
                        href="/"
                        underline="none"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="body1"
                          fontSize="18px"
                          lineHeight="28px"
                          className="interlinking"
                        >
                          www.invimatic.com
                        </Typography>
                      </Link>
                      <Link
                        href="mailto:contact@invimatic.com"
                        underline="none"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="body1"
                          fontSize="18px"
                          lineHeight="28px"
                          className="interlinking"
                        >
                          contact@invimatic.com
                        </Typography>
                      </Link>
                    </Stack>

                    {/* Social Media Icons */}
                    <Stack direction="row" spacing={3} pb={3.75}>
                      {socialMediaIcons.map((item, index) => (
                        <Link href={item?.url} underline="none" target="_blank">
                          <IconButton
                            key={index}
                            aria-label={item.ariaLabel}
                            sx={{ width: "15px", height: "15px", p: 0 }}
                          >
                            <img
                              src={item.icon}
                              alt={item.ariaLabel}
                              style={{
                                width:
                                  item.ariaLabel === "Twitter"
                                    ? "22px"
                                    : "18px",
                                height:
                                  item.ariaLabel === "Twitter"
                                    ? "22px"
                                    : "18px",
                              }}
                            />
                          </IconButton>
                        </Link>
                      ))}
                    </Stack>
                  </Stack>
                </Stack>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  bgcolor: "white",
                  pl: 3,
                  pt: 3.75,
                  pr: 2,
                  pb: 3.75,
                  mt: 4,
                  mb: 6,
                }}
              >
                <Stack
                  spacing={0}
                  width="100%"
                  sx={{
                    height: "77.7rem",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <Typography
                    variant="h4"
                    fontWeight="bold"
                    color="black"
                    mb={0.5}
                  >
                    More News
                  </Typography>

                  {newsItems.map((item, index) => (
                    <Box key={item.id}>
                      <Link href={item.url} underline="none">
                        <Card
                          elevation={0}
                          sx={{
                            display: "flex",
                            py: 3.125,
                            px: 0,
                            borderRadius: 0,
                          }}
                        >
                          <CardMedia
                            component="div"
                            sx={{
                              width: 140,
                              height: 120,
                              backgroundImage: `url(${item.image})`,
                              backgroundSize: "cover",
                              backgroundPosition: "50% 50%",
                              flexShrink: 0,
                            }}
                          />
                          <CardContent
                            sx={{
                              p: 0,
                              pl: 2,
                              pb: "0px !important",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-around",
                            }}
                          >
                            <Stack spacing={1.5}>
                              <Typography
                                fontFamily="Bitter, Helvetica"
                                fontWeight="bold"
                                color="#1a1a1a"
                                fontSize={16}
                                lineHeight="20.8px"
                                sx={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                }}
                                title={item.title}
                              >
                                {item.title}
                              </Typography>

                              <Typography
                                fontFamily="Mulish, Helvetica"
                                color="text.secondary"
                                fontSize={12}
                                sx={{
                                  minHeight: "38px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                }}
                                title={item.excerpt}
                              >
                                {item.excerpt}
                              </Typography>

                              <Typography
                                fontFamily="Mulish, Helvetica"
                                fontSize={13}
                                lineHeight="13px"
                              >
                                <Box
                                  component="span"
                                  fontWeight="bold"
                                  color="rgba(9, 9, 32, 0.7)"
                                >
                                  {item.author}
                                </Box>
                              </Typography>
                            </Stack>
                          </CardContent>
                        </Card>
                      </Link>
                      {index < newsItems.length - 1 && (
                        <Divider sx={{ width: "100%" }} />
                      )}
                    </Box>
                  ))}
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* more release */}
      {/* <section>
        <Box
          sx={{
            p: 7,
            bgcolor: "#021220",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "white",
              fontSize: "27px",
              marginBottom: "40px",
            }}
          >
            More Press Releases
          </Typography>

          <Box>
            <Grid container spacing={5.5}>
              {pressReleases.map(item => (
                <Grid item xs={12} md={4} key={item.id}>
                  <Link href="/" underline="none">
                    <Card
                      sx={{
                        position: "relative",
                        width: "100%",
                        height: 325,
                        borderRadius: "10px",
                        border: "1px solid #d3e6ff",
                        boxShadow: "0px 10px 30px rgba(177, 202, 235, 0.6)",
                        transition: "all 0.3s ease-in-out !important",
                        background:
                          "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(211,230,255,1) 100%)",
                        "&:hover": {
                          background:
                            "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(230,241,255,1) 100%)",
                          "& .cardContent": {
                            padding: 0,
                          },
                          "& .cardMedia": {
                            display: "none",
                          },
                          "& .card-text": {
                            color: "white",
                            transform: "translateY(-56px)",
                            padding: "31.2px",
                          },
                          "& .read-more": {
                            display: "block",
                          },
                          "& .icon": {
                            filter: "invert(1)",
                          },
                          "& .hover-box": {
                            position: "absolute",
                            opacity: 1,
                            visibility: "visible",
                          },
                        },
                      }}
                    >
                      <Box className="cardContent">
                        <CardMedia
                          component="div"
                          className="cardMedia"
                          sx={{
                            position: "absolute",
                            width: "110px",
                            height: "130px",
                            top: 20,
                            right: 20,
                            borderRadius: "10px 10px 10px 90px",
                            backgroundImage: `url(${item.imageUrl})`,
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                            display: "block",
                            transition: "transform 0.3s ease-in-out",
                          }}
                        />

                        <Stack
                          spacing={3.75}
                          className="card-text"
                          sx={{
                            position: "absolute",
                            top: 60,
                            p: 3.9,
                            transition: "transform 0.5s ease-in-out",
                            zIndex: 1,
                          }}
                        >
                          <Box
                            component="img"
                            src={item.iconUrl}
                            className="icon"
                            sx={{
                              width: "50px",
                              height: "50px",
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "22px",
                              fontWeight: 700,
                            }}
                          >
                            {item.title}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "18px",
                              marginTop: "5px !important",
                              lineHeight: "24px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              "-webkit-line-clamp": "4",
                              "-webkit-box-orient": "vertical",
                            }}
                          >
                            {item.description}
                          </Typography>
                          <Typography
                            className="read-more"
                            sx={{
                              fontSize: "18px",
                              marginTop: "20px !important",
                              textDecoration: "underline",
                              display: "none",
                            }}
                          >
                            Read More...
                          </Typography>
                        </Stack>
                        <Box
                          component="img"
                          src={morePressHover}
                          alt="Image"
                          className="hover-box"
                          sx={{
                            borderRadius: "10px",
                            boxShadow: "0px 15px 40px rgba(177, 202, 235, 0.8)",
                            transition:
                              "opacity 0.5s ease-in-out, visibility 0.5s !important",
                            background: `url(${morePressHover})`,
                            backgroundSize: "cover",
                            width: "100%",
                            height: "auto",
                            opacity: 0,
                            visibility: "hidden",
                          }}
                        />
                      </Box>
                    </Card>
                  </Link>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </section> */}

      <section
        className="discussYourProject"
        style={{
          borderTop: isMobile ? "1px solid rgb(181 181 181 / 50%)" : "unset",
        }}
      >
        <Container maxWidth="lg">
          <Stack
            sx={{
              position: "relative",
              zIndex: 1,
              pt: isMobile ? 0 : 5,
              pb: 0,
            }}
            direction={isMobile ? "column" : "row"}
            alignItems="center"
          >
            <Stack
              alignItems="center"
              gap={6}
              sx={{ width: isMobile ? "100%" : "50%" }}
            >
              <Stack alignItems="center" textAlign="center" gap={2}>
                {isMobile ? (
                  <></>
                ) : (
                  <img
                    src={chatIcon}
                    alt="Chat"
                    style={{ width: "auto !important" }}
                  />
                )}
                <Typography
                  variant="body1"
                  fontSize={isMobile ? 32 : 16}
                  fontWeight={isMobile ? 700 : 600}
                  color={isMobile ? "#fff" : "#C8DCFA"}
                  textAlign="center"
                >
                  Let's discuss your project
                </Typography>
                {isMobile ? (
                  <></>
                ) : (
                  <Typography
                    variant="h4"
                    color="#fff"
                    fontSize="20px"
                    fontWeight={700}
                    lineHeight="28px"
                    padding="0 30px"
                  >
                    Looking to scale your SaaS effortlessly? <br />
                    Share your project details, and we'll provide tailored
                    solutions to support the growth and security of your SaaS
                    business.
                  </Typography>
                )}
              </Stack>
            </Stack>
            <Box
              sx={{
                width: isMobile ? "100%" : "50%",
                marginTop: isMobile ? "20px" : "0px",
              }}
            >
              <Enquiry />
            </Box>
          </Stack>
        </Container>
      </section>
    </Layout>
  )
}

export default IsoCertificationInvimatic
